<mat-form-field class="w-full">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [value]="value()"
    [min]="min()"
    [max]="max()"
    [readonly]="readonly()"
    [disabled]="isDisabled()"
    [placeholder]="placeholder()"
    (dateChange)="onDateChange($event)"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
